<template>
  <section class="page-wrap">
    <!-- 搜索模块 start -->
    <section class="form jn-form-style">
      <div class="form-item btn-wrap">
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-refresh"
          title="重置"
          jn-refresh-btn
          @click="onRefresh"
        ></el-button>
      </div>

      <div class="form-item">
        <el-date-picker
          type="daterange"
          range-separator="至"
          start-placeholder="结算日期起"
          end-placeholder="结算日期止"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          align="right"
          v-model="dataTime3"
          @change="changeDate3"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>

      <div class="form-item">
        <el-date-picker
          type="daterange"
          range-separator="至"
          start-placeholder="供货日期起"
          end-placeholder="供货日期止"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          align="right"
          v-model="dataTime1"
          @change="changeDate1"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>

      <div class="form-item">
        <el-date-picker
          type="daterange"
          range-separator="至"
          start-placeholder="支付日期起"
          end-placeholder="支付日期止"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          align="right"
          v-model="dataTime2"
          @change="changeDate2"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
      </div>

      <div class="form-item">
        <el-select
          placeholder="选择自提点"
          v-model="formData.store_delivery_id"
          v-loading="loadingData"
          filterable
          clearable
        >
          <el-option
            v-for="item in deliveryList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </div>

      <div class="form-item">
        <el-select
          placeholder="选择结转状态"
          v-model="formData.status"
          clearable
        >
          <el-option
            v-for="item in overStatusList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>

      <div class="form-item">
        <el-input placeholder="输入货号" v-model="formData.sku_code" clearable>
        </el-input>
      </div>

      <div class="form-item">
        <el-input
          placeholder="输入订单号"
          v-model="formData.order_no"
          clearable
        >
        </el-input>
      </div>

      <div class="form-item">
        <el-button
          slot="suffix"
          type="primary"
          size="medium"
          icon="el-icon-search"
          @click="onHandleSearch('click')"
          >查询</el-button
        >
        <el-button
          @click="onHandleExport"
          :disabled="!dataList.length || disabledExport"
          type="warning"
          icon="el-icon-download"
          >导 出</el-button
        >
      </div>
    </section>
    <!-- 搜索模块 end -->

    <!-- 列表数据 start -->
    <section class="content" v-loading="loading">
      <table-list :dataList="dataList"></table-list>
    </section>
    <!-- 列表数据 end -->

    <!-- 分页 start -->
    <div class="pagination">
      <el-pagination
        type="primary"
        :current-page="formData.page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="formData.pageSize"
        :total="total"
        @size-change="onHandleSizeChange"
        @current-change="onHandleCurrentChange"
        layout="total, sizes, prev, pager, next, jumper"
        background
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </section>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import TableList from "./modules/table-list";
import {
  getSettlementLogisticsOfTdc,
  getSettlementLogisticsOfTdcExport,
} from "@/api/tdc/index";
import { getDeliveryListOfTdc } from "@/api/tdc/delivery";
import { OVER_STATUS } from "../utils/enum/index";
import { downLoadFlowBlob } from "@/utils/tools/base";

export default {
  name: "TdcAccountDetails",
  components: {
    TableList,
  },
  data() {
    return {
      loading: false,
      disabledExport: false, // 导出禁用
      loadingData: false,
      overStatusList: Object.values(OVER_STATUS), // 结转状态下拉
      dataTime1: [], // 时间对象
      dataTime2: [], // 时间对象
      dataTime3: [], // 时间对象
      formData: {
        start_convert_date: "", // 结算日期起
        end_convert_date: "", // 结算日期止
        start_date: "", // 供货日期起
        end_date: "", // 供货日期止
        start_pay_at: "", // 支付日期起
        end_pay_at: "", // 支付日期止

        store_delivery_id: "", // 自提点ID
        status: "", // 结转状态
        sku_code: "", // 货号
        order_no: "", // 订单号
        page: 1,
        pageSize: 10,
      }, // 表单数据
      formDataClone: {}, // 拷贝一份数据，用于重置
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      }, // 时间范围
      dataList: [], // 列表数据
      total: 0,
      deliveryList: [], // 自提点列表
    };
  },
  mounted() {
    this.onInitData();
  },
  methods: {
    /**
     * 初始化数据
     */
    onInitData() {
      this.formDataClone = cloneDeep(this.formData);
      this.ajaxGetSelfTakeList();
      this.onHandleSearch();
    },
    /**
     * 查询数据
     */
    onHandleSearch(type) {
      if (type === "click") {
        this.formData.page = 1;
      }
      this.dataList = [];
      // this.total = 0;
      this.ajaxGetCityReconciliationDetail();
    },
    /**
     * 每页条数发生改变
     */
    onHandleSizeChange(val) {
      this.formData.page = 1;
      this.formData.pageSize = val;
      this.onHandleSearch();
    },
    /**
     * 页码发生改变
     */
    onHandleCurrentChange(val) {
      this.formData.page = val;
      this.onHandleSearch();
    },
    /**
     * 重置表单数据
     */
    onRefresh() {
      this.dataTime1 = [];
      this.dataTime2 = [];
      this.dataTime3 = [];
      this.deliveryList = [];
      this.formData = {
        ...this.formDataClone,
      };
      this.onHandleSearch();
    },
    /**
     * 获取自提点列表
     */
    async ajaxGetSelfTakeList() {
      this.loadingData = true;
      const params = {
        name: "",
        page: 1,
        pageSize: 1000,
      };
      try {
        const { data } = await getDeliveryListOfTdc(params);
        const { data: list } = data;
        this.deliveryList = list;
      } catch (err) {
        console.log("ajax getDeliveryListOfTdc err", err);
      } finally {
        this.loadingData = false;
      }
    },
    /**
     * 获得结算详情列表
     */
    async ajaxGetCityReconciliationDetail() {
      this.loading = true;
      const params = { ...this.formData };
      try {
        const { data } = await getSettlementLogisticsOfTdc(params);
        console.log("ajax getSettlementLogisticsOfTdc", data);
        const { total, data: list } = data;
        this.total = total;
        this.dataList = list;
      } catch (err) {
        console.log("ajax getSettlementLogisticsOfTdc err", err);
      } finally {
        this.loading = false;
      }
    },
    /**
     * 导出数据（下载中心）
     */
    async onHandleExport() {
      this.disabledExport = true;
      // this.$message.success({
      //   message: "正在导出，请耐心等待",
      //   duration: 99999999,
      // });
      // try {
        const params = {
          ...this.formData,
        };
        delete params.page;
        delete params.pageSize;
        this.$api.biexport.tdcsettlementdetailexport(params).then(res=>{
              this.disabledExport = false;
        
        this.goExportCenter()
      }).catch(err=>{
            this.disabledExport = false;
        
      })
      // } catch (err) {
      //   console.log("ajax getSettlementLogisticsOfTdcExport err", err);
      // } finally {
      //   this.disabledExport = false;
      //   this.$message.closeAll();
      // }
    },
     /**
     * 导出后引导弹框
     */
     goExportCenter() {
      // 新窗口打开下载中心
      const routerInfo = this.$router.resolve({
        path: "/export-center",
      });
      window.open(routerInfo.href, "_blank");
      this.disabledExport = false;
    },
    /**
     * 供货日期发生了变化
     */
    changeDate1(data) {
      this.formData.start_date = data?.[0] || "";
      this.formData.end_date = data?.[1] || "";
    },
    /**
     * 支付日期发生了变化
     */
    changeDate2(data) {
      this.formData.start_pay_at = data?.[0] || "";
      this.formData.end_pay_at = data?.[1] || "";
    },
    /**
     * 结算日期发生了变化
     */
    changeDate3(data) {
      this.formData.start_convert_date = data?.[0] || "";
      this.formData.end_convert_date = data?.[1] || "";
    },
  },
};
</script>

<style lang="scss" scoped>
.page-wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  .form {
    padding: 13px 15px;
  }
  .content {
    flex: 1;
    overflow-y: hidden;
  }
  .pagination {
    padding: 10px 20px;
    box-sizing: border-box;
  }
}
</style>
